// extracted by mini-css-extract-plugin
module.exports = {"collapsibleArrow":"collapsibleArrow_3SPQbRx1fV","collapsible":"collapsible_2vcMcsg9Nt","searchLabel":"searchLabel_1hbOhxHWWU"};